import { Input, Switch } from "antd";
import { useState, useEffect } from "react";
import localforage from "localforage";
import { StarFilled } from "@ant-design/icons";

const { Search } = Input;

export default function SearchComponent({
  handleSearch,
  currentLocation,
  selectedBusinessType,
  fetchNearbyBusinesses,
  getFavorites,
  loading,
  searchValue,
  setSearchValue
}) {
  const [isEnabled, setFavoritesEnabled] = useState(false);
  useEffect(() => {
    // Fetch the value from localforage asynchronously
    const fetchFavoritesEnable = async () => {
      let favoritesEnable = await localforage.getItem("favorites_enable");
      await localforage.getItem("favorites_userIds").then((favorites) => {
        if (!(favorites || []).length) {
          favoritesEnable = false
        }
      });
      setFavoritesEnabled(favoritesEnable || false); // Default to false if null/undefined
      favoritesEnable || false
        ? getFavorites(setFavoritesEnabled)
        : fetchNearbyBusinesses(
            currentLocation,
            selectedBusinessType,
            setFavoritesEnabled
          );
    };

    fetchFavoritesEnable();
  }, []);

  // useEffect(() => {
  //   setSearchValue("");
  // }, [isEnabled]);

  return (
    <div className="search-bar-container">
      <Search
        style={{ width: "75%" }}
        placeholder={`Search for all ${selectedBusinessType}s`}
        value={searchValue} // Controlled value
        onSearch={(value) => handleSearch(value, setFavoritesEnabled)}
        onChange={(e) => {
          const value = e.target.value;
          setSearchValue(value); // Update the state with the new value
          if (value === "") {
            fetchNearbyBusinesses(currentLocation, selectedBusinessType);
          } else {
            // throttle(() => handleSearch(value), 1000);
          }
        }}
        enterButton
      />
      <div className="switch-container">
        <Switch
          disabled={loading}
          checked={isEnabled}
          onChange={(bool) => {
            setSearchValue("");
            bool
              ? getFavorites(setFavoritesEnabled)
              : fetchNearbyBusinesses(
                  currentLocation,
                  selectedBusinessType,
                  setFavoritesEnabled
                );
          }}
        >
          aaa
        </Switch>
        <span className="favorites-text"><StarFilled style={{color:"#ffcc00", marginRight: "2px"}}/>favorites</span>
      </div>
    </div>
  );
}
